<div class="container">
  <div class="row">
    <div class="col col-12">
      <h5>{{ 'productDetails.bimTab.title' | transloco }}</h5>
      <boels-bim-model-list
        [product$]="componentData.product$"
      ></boels-bim-model-list>
      <p>{{ 'productDetails.bimTab.explanatory' | transloco }}</p>
    </div>
  </div>
</div>
